import './UploadFile.scss';
import { Button, IconButton } from '@mui/material';
import { useEffect, useState } from 'react';
import { Delete } from '@mui/icons-material';
import { useUploadFileMutation } from '../../store/modalSlice';

interface Event<T = EventTarget> {
  target: T;
}

interface uploadPropI {
  id: string;
  type: string;
}

const UploadFile = (props: uploadPropI) => {
  const { id, type } = props;
  const [selectedFiles, setSelectedFiles] = useState<Array<File>>([]);
  const [uploadFile, { error: errorUpload, data: response, isSuccess: isSuccessUpload }] =
    useUploadFileMutation();

  const onChangeFile = async (e: Event<HTMLInputElement>) => {
    const files = e.target.files;
    if (files) {
      const myFiles = Array.from(files);
      setSelectedFiles([...selectedFiles, ...myFiles]);
    }
  };

  const removeFile = (idx: number) => {
    const newArrFiles = selectedFiles.filter((el, i) => i !== idx);
    setSelectedFiles(newArrFiles);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    for (let i = 0; i < selectedFiles.length; i++) {
      formData.append('appealfile[]', selectedFiles[i]);
    }
    formData.append('appealId', id);

    try {
      await uploadFile({ formData, type }).unwrap();
      setSelectedFiles([]);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="file">
      <div className="file-wrapper">
        <ul>
          {selectedFiles &&
            selectedFiles.map((file, idx) => {
              return (
                <li key={idx}>
                  {file.name}
                  <IconButton
                    onClick={() => removeFile(idx)}
                    color="primary"
                    aria-label="upload file"
                    component="button"
                  >
                    <Delete />
                  </IconButton>
                </li>
              );
            })}
        </ul>
      </div>
      <div className="file-buttons">
        <Button variant="contained" component="label">
          Выбрать файлы
          <input
            onChange={onChangeFile}
            multiple
            hidden
            type="file"
            name="appealfile"
            id="appealFileInput"
          />
        </Button>

        <Button
          variant="contained"
          onClick={handleUpload}
          disabled={!selectedFiles || selectedFiles.length === 0}
        >
          Загрузить
        </Button>
      </div>
    </div>
  );
};

export default UploadFile;